import React, { useContext } from 'react'
import styled from 'styled-components'
import { header, margin, marginSizes } from '@jarvis.oddle/core/theme/default'
import { numberise, pixelise } from '@jarvis.oddle/core/tools/style'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import VerticalNavigation from 'src/components/molecules/VerticalNavigation'
import { useRouter } from 'next/router'

const StyledVerticalNavigation = styled(VerticalNavigation)`
  position: sticky;
  top: ${pixelise(
    header.desktopHeight + numberise(margin[marginSizes.medium])
  )};
`

export const pagesArray = [
  {
    id: 'addressBook',
    name: 'Address Book',
    href: '/[locale]/user/addresses',
    as: '/user/addresses'
  },
  {
    id: 'accountDetails',
    name: 'Account Details',
    href: '/[locale]/user/details',
    as: '/user/details'
  },
  {
    id: 'paymentMethods',
    name: 'Payment Methods',
    href: '/[locale]/user/payment-methods',
    as: '/user/payment-methods'
  },
  {
    id: 'orderHistory',
    name: 'Order History',
    href: '/[locale]/user/orders',
    as: '/user/orders'
  }
]

export const getTranslatedPagesArray = (
  t: (x) => string,
  locale: string
): Record<string, string>[] =>
  pagesArray.map((p) => ({
    ...p,
    name: t(p.name),
    as: `/${locale}${p.as}`
  }))

export const pages = pagesArray.reduce(
  (obj, page) => ({ ...obj, [page.id]: page.id }),
  {}
)

interface UserPagesNavigationProps {
  currentPage: string
}

const UserPagesNavigation = ({
  currentPage
}: UserPagesNavigationProps): JSX.Element => {
  const { t } = useContext(TranslationContext)
  const router = useRouter()
  return (
    <StyledVerticalNavigation
      items={getTranslatedPagesArray(t, router.query.locale as string)}
      selectedItemId={currentPage}
    />
  )
}

export default UserPagesNavigation
